import React from 'react'
import BaseLayout from './BaseLayout'
import { observer } from "mobx-react-lite"
import useTitle from '../../hooks/title'
import classes from './styles.module.scss'


const AcceptableUseAndFairUsagePolicy = observer(() => {
    useTitle('Accepatable Use and Fair Usage Policy');
  return <BaseLayout>
    <div className={classes['head1']}>
        <h1>Acceptable Use and Fair Usage Policy</h1>
    </div>

    <div className={classes['head2']}>
        <h2>Acceptable Use</h2>
    </div>
    
    <div className={classes['paragraph']}>
        <p>Session Loops Inc. (“Session Loops”)s services and websites (the “Service”) are intended to be used by millions of people, and we trust you to use the Service responsibly.</p>
        <p> This Acceptable Use and Fair Usage Policy should be read together with our Terms of Service.</p>
        <p> You agree not to misuse the Service. For example, you must not, and must not attempt to, use the services to do the following things:</p>

        <ol>
            <li>probe, scan, or test the vulnerability of any system or network;</li>
            <li>breach or otherwise circumvent any security or authentication measures;</li>
            <li>access, tamper with, or use non-public areas of the Service, shared areas of the Service you have not been invited to, 	Landr’s (or our service providers’) computer systems;</li>
            <li>interfere with or disrupt any user, host, or network, for example by sending a virus, overloading, flooding, spamming, or mail-	bombing any part of the Services;</li>
            <li>plant malware or otherwise use the Services to distribute malware;</li>
            <li>access or search the Services by any means other than our publicly supported interfaces (for example, “scraping”);</li>
            <li>send unsolicited communications, promotions or advertisements, or spam;</li>
            <li>publish anything that is fraudulent, misleading, or infringes another person’s rights;</li>
            <li>promote or advertise products or services other than your own without appropriate authorization;</li>
            <li>publish or share materials that are unlawfully pornographic or indecent, or that advocate bigotry, religious, racial or ethnic 	hatred;</li>
            <li>violate the law in any way, or to violate the privacy of others, or to defame others;</li>
            <li>Impersonate or misrepresent your affiliation with any person or entity;</li>
            <li>attempt to decipher, decompile, disassemble, or reverse engineer any of the software used to provide the Service;</li>
            <li>harm or threaten to harm other users in any way or interfere with, or attempt to interfere with, the access of any user, host or 	network, including without limitation, by sending a virus, overloading, flooding, spamming, or mail-bombing the Service;</li>
            <li>provide payment information belonging to a third party;</li>
            <li>use the Service in an abusive way contrary to its intended use, to its documentation or to Landr Audio’s reasonable 	instructions;</li>
            <li>If you make available or share material using the Services for which you don't own the copyright or a license allowing you to 	do so, Session Loops may remove it without prior notice.
            </li>                
        </ol>
    </div>
    
    <div className={classes['paragraph']}>
        <p>Read our Terms of Service for more information.</p>
    </div>

    <div className={classes['head2']}>
        <h2>Fair Usage</h2>
    </div>

    <div className={classes['paragraph']}>
        <p>Session Loops has prepared this policy as a guide for you to understand the intended uses of our Services, and to prevent exploitation and abuse of the unlimited features offered in our plans.</p>

    </div>

    <div className={classes['head2']}><h3>Normal, Reasonable Personal or Professional Use</h3></div>

    <div className={classes['paragraph']}>
        <p>The Service as offered in our plans is intended for normal, reasonable personal or professional use. “Unlimited” refers to that type and level of usage. Normal, reasonable personal or professional use does not include commercial uses, such as operating a business where you use the Services to create an abnormally high number of samples (in exchange for fees or not) compared to the typical user for personal or professional purposes.
        </p>
    </div>

    <div className={classes['head2']}><h3>Evaluation</h3></div>
    
    <div className={classes['paragraph']}>
        <p>Session Loops evaluates your usage in comparison to typical levels of usage engaged in by other users. Based on such evaluation, Session Loops may determine that abnormal, unreasonable usage is occurring when compared to typical users.</p>
        <p>Although we do not wish to set a specific limit, as a guideline, we will generally consider that your usage is abnormal or unreasonable if you regularly create ninety nine  (99) tracks per day or more, or nine hundred and ninety-nine (999) tracks per month.</p>
        <p>We understand that your use of the Services may be irregular, with periods where you may wish to create several samples and other where you may not wish to create any sample, and as such we will review and evaluate your use accordingly.</p>

    </div>

    <div className={classes['head2']}>
        <h3>Notification</h3>
    </div>
    <div className={classes['paragraph']}>
        <p>If Session Loops determines that your use is abnormal or unreasonable, we will contact you (via the email address provided in your account) to inform you of your usage, and may give you the opportunity to correct your usage or offer you to subscribe to a different plan. We also reserve the right to take any further action, including suspending immediately your account and your use of the Service, or closing your account.</p>
    </div>
  </BaseLayout>
})

export default AcceptableUseAndFairUsagePolicy